import _ from 'lodash'
import clx from 'classnames'
import styles from './RankingTable.css'
import { numeralFormat, dollarFormat, convertDateByMoment } from '../../../../../../lib/renderUtil'
import { pullLeft, pullRight } from '../../../../../styles/shared.css'
import { HyperLink } from '../../../../Common/Form'
import CommonRankingTable from '../../../../Common/NewDashboard/Table/RankingTable/RankingTable'
import { ConnectedListingLink } from '../../../../Common/ListingLink/ListingLink'
import TooltipIcon from '../../../../Common/TooltipIcon/TooltipIcon'
import {
  FIELD as SORT_FIELD,
  FIELD_MAP as SORT_FIELD_MAP,
  QUANTITY_TYPE_FIELD_MAP
} from '../constants'
import { SUB_ANCHOR_MAP } from '../../../constants'
import { YESTERDAY } from '../../../../../constants/date'
import { Icon } from '@vzmi/shp_shared_compo'
import eCoupon from '@vzmi/svg-icons-ec/icons/ec-coupon2'
import YPopover from '../../../../Common/Popover'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import { getAvailableCountLink } from '../../Shared'

export const FIELD = {
  ...SORT_FIELD,
  LISTING_ID: 'listingId',
  LISTING_NAME: 'listingName',
  ITEM_PRICE: 'itemPrice',
  AMOUNT: 'amount',
  AVAILABLE_COUNT: 'availableCount'
}

export const FIELD_MAP = {
  ...SORT_FIELD_MAP,
  [FIELD.LISTING_ID]: '賣場編號',
  [FIELD.LISTING_NAME]: '賣場名稱',
  [FIELD.ITEM_PRICE]: '目前售價',
  [FIELD.AMOUNT]: '訂購金額',
  [FIELD.AVAILABLE_COUNT]: '可訂購量'
}

export const TARGET_AUDIENCE = {
  YESTERDAY_ABANDONED_CART: 'yesterdayAbandonedCart',
  ABANDONED_CART: 'abandonedCart',
  ABANDONED_CART_QUANTITY: 'abandonedCartQuantity'
}

export const getAllSpecInfo = data =>
  [...data.parentSpec ? [data.parentSpec] : [],
    ...data.spec ? [data.spec] : []].map(specs =>
    Object.values(specs).join('：')
  ).join('、')

const ABANDONEDCARTS_TOOLTIP_TITLE = '賣場被放入購物車後，未結帳的賣場數量，不同屬性、配送方式會重複計算。'

const getColumns = props => [
  {
    id: 'listingAndName',
    headerClassName: clx(pullLeft, styles.listingAndNameCol),
    className: clx(pullLeft, styles.listingAndNameCol),
    Header: `${FIELD_MAP[FIELD.LISTING_ID]}／${FIELD_MAP[FIELD.LISTING_NAME]}${props.statsType !== SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ARRIVALNOTICE.link
      ? ''
      : '／規格'
    }`,
    Cell: row => {
      const {
        listingId,
        listingName,
        spec,
        parentSpec
      } = _.get(row, 'original', {})

      return (
        <p className={styles.listing}>
          <ConnectedListingLink
            targetListingId={listingId}
          >
            {listingId}
          </ConnectedListingLink>
          <br />
          {listingName}
          {spec && (
            <div className={styles.specInfo}>
              {getAllSpecInfo({ spec, parentSpec })}
            </div>
          )}
        </p>
      )
    }
  },
  {
    id: FIELD.QUANTITY,
    accessor: FIELD.QUANTITY,
    width: 115 + (props.statsType === SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS.link
      ? 0
      : 25),
    Header: () => {
      const tooltipTitle = {
        [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS.link]: ABANDONEDCARTS_TOOLTIP_TITLE,
        [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ARRIVALNOTICE.link]: '該屬性商品缺貨後，買家申請貨到通知的次數。',
        [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_TRACKITEM.link]: '不同買家將該賣場加入收藏列表的次數。'
      }
      return (
        <>
          {FIELD_MAP[QUANTITY_TYPE_FIELD_MAP[props.statsType]]}
          <TooltipIcon
            tooltipTitle={tooltipTitle[props.statsType]}
          />
        </>
      )
    },
    headerClassName: clx(pullRight, styles.col),
    className: clx(pullRight, styles.col),
    Cell: row => {
      const { isPM } = props
      const { listingId, showAbandonedCartIcon } = _.get(row, 'original', {})
      return (
        <>
          {numeralFormat(row.value, { allowZero: true })}
          {(showAbandonedCartIcon && !isPM) && (
            <YPopover
              placement='top'
              content='點擊可發送折價券，促進買家結帳意願！'
            >
              <Icon
                data-role='eCouponIcon'
                className={styles.eCouponIcon}
                asset={eCoupon}
                color='purple'
                size={20}
                onClick={() => props.fetchListingsInfo(listingId, TARGET_AUDIENCE.ABANDONED_CART)}
              />
            </YPopover>

          )}
        </>
      )
    }
  },
  ...(props.statsType !== SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS.link
    ? []
    : [{
      id: FIELD.YESTERDAY_QUANTITY,
      accessor: FIELD.YESTERDAY_QUANTITY,
      width: 150,
      Header: () => (
        <>
          {FIELD_MAP[FIELD.YESTERDAY_QUANTITY]}
          <TooltipIcon
            tooltipTitle={`昨日(${convertDateByMoment(YESTERDAY, 'MM/DD')})剛被買家加入購物車之賣場數`}
          />
        </>
      ),
      headerClassName: clx(pullRight, styles.col, styles.specInfo),
      className: clx(pullRight, styles.col, styles.specInfo),
      Cell: row => {
        const { flags, isPM } = props
        const { listingId, showYesterdayAbandonedCartIcon } = _.get(row, 'original', {})
        const discountFeatureToggle = getFeatureToggle(flags, 'sp_discount')
        return (
          <>
            {numeralFormat(row.value, { allowZero: true })}
            {(discountFeatureToggle && showYesterdayAbandonedCartIcon && !isPM) && (
              <YPopover
                placement='top'
                content='點擊可發送折價券，促進買家結帳意願！'
              >
                <Icon
                  data-role='eCouponIcon'
                  className={styles.eCouponIcon}
                  asset={eCoupon}
                  color='purple'
                  size={20}
                  onClick={() => props.fetchListingsInfo(listingId, TARGET_AUDIENCE.ABANDONED_CART)}
                />
              </YPopover>

            )}
          </>
        )
      }
    }]
  ),
  ...(props.statsType !== SUB_ANCHOR_MAP.CUSTOMER_INTEREST_TRACKITEM.link
    ? []
    : [{
      id: FIELD.ABANDONED_CART_QUANTITY,
      accessor: FIELD.ABANDONED_CART_QUANTITY,
      width: 125,
      Header: () => (
        <>
          {FIELD_MAP[FIELD.ABANDONED_CART_QUANTITY]}
          <TooltipIcon
            tooltipTitle={ABANDONEDCARTS_TOOLTIP_TITLE}
          />
        </>
      ),
      headerClassName: clx(pullRight, styles.col),
      className: clx(pullRight, styles.col),
      Cell: row => {
        const { isPM } = props
        const { listingId, showAbandonedCartQuantityIcon } = _.get(row, 'original', {})
        return (
          <>
            {numeralFormat(row.value, { allowZero: true })}
            {(showAbandonedCartQuantityIcon && !isPM) && (
              <YPopover
                placement='top'
                content='點擊可發送折價券，促進買家結帳意願！'
              >
                <Icon
                  data-role='eCouponIcon'
                  className={styles.eCouponIcon}
                  asset={eCoupon}
                  color='purple'
                  size={20}
                  onClick={() => props.fetchListingsInfo(listingId, TARGET_AUDIENCE.ABANDONED_CART_QUANTITY)}
                />
              </YPopover>

            )}
          </>
        )
      }
    }, {
      id: FIELD.PAGE_VIEW_30D,
      accessor: FIELD.PAGE_VIEW_30D,
      width: 125,
      Header: () => (
        <>
          {FIELD_MAP[FIELD.PAGE_VIEW_30D]}
          <TooltipIcon
            tooltipTitle='賣場被造訪的次數'
          />
        </>
      ),
      headerClassName: clx(pullRight, styles.col),
      className: clx(pullRight, styles.col),
      Cell: row => numeralFormat(row.value, { allowZero: true })
    }]
  ),
  {
    id: FIELD.ITEM_PRICE,
    accessor: FIELD.ITEM_PRICE,
    width: 90,
    Header: FIELD_MAP[FIELD.ITEM_PRICE],
    headerClassName: clx(pullRight, styles.col),
    className: clx(pullRight, styles.col),
    Cell: row => {
      const {
        sku: productId,
        skuSubStationId
      } = _.get(row, 'original', {})
      const subNo = _.head(/\d+/.exec(skuSubStationId))
      const query = `?productIds=${productId}&subNo=${subNo}`
      const link = `${_.get(props, 'sharedLink.scmProductCostPrice')}${query}`
      return (
        <HyperLink
          target='_blank'
          href={link}
          onClick={() => props.sendTableLinkPageview(FIELD.ITEM_PRICE)}
        >
          {dollarFormat(row.value)}
        </HyperLink>
      )
    }
  },
  {
    id: FIELD.AMOUNT,
    accessor: FIELD.AMOUNT,
    width: 115,
    Header: FIELD_MAP[FIELD.AMOUNT],
    headerClassName: clx(pullRight, styles.col),
    className: clx(pullRight, styles.col),
    Cell: row => dollarFormat(row.value)
  },
  {
    id: FIELD.AVAILABLE_COUNT,
    accessor: FIELD.AVAILABLE_COUNT,
    width: 130,
    Header: FIELD_MAP[FIELD.AVAILABLE_COUNT],
    headerClassName: clx(pullRight, styles.col, styles.lastCol),
    className: clx(pullRight, styles.col, styles.lastCol),
    Cell: row => {
      const { sharedLink, sendTableLinkPageview } = props
      const { shipType, listingId } = _.get(row, 'original', {})
      const availableCountLink = getAvailableCountLink(sharedLink, shipType, listingId)
      return (
        <HyperLink
          target='_blank'
          href={availableCountLink}
          onClick={() => sendTableLinkPageview(FIELD.AVAILABLE_COUNT)}
        >
          {numeralFormat(row.value, { allowZero: true })}
        </HyperLink>
      )
    }
  }
]

const RankingTable = props => {
  return (
    <CommonRankingTable
      sortable={false}
      resizable={false}
      showPagination={false}
      data={props.data}
      columns={getColumns(props)}
      rankingColumnProps={{
        width: 40,
        Header: '排行'
      }}
      {...props}
    />
  )
}

export default RankingTable
